import { Component, OnInit, Input } from '@angular/core';
import { Document } from '../../document';
import { environment } from 'environments/environment';

@Component({
  selector: 'lms-documents-list-row',
  templateUrl: './documents-list-row.component.html',
  styleUrls: ['./documents-list-row.component.css']
})
export class DocumentsListRowComponent implements OnInit {
  @Input() document: Document;

  getDocumentUrl() {
    const url = this.document.url;
    if (!url.startsWith('https://')) {
      const streamingTypes = ['.mp3', '.m4a', '.wav', '.mp4', '.mov', '.webm', '.MPG'];
      const host = streamingTypes.find((type) => url.includes(type))
        ? environment.STREAMING_HOST
        : environment.RESOURCES_HOST;
      return host + url;
    }
    return url;
  }

  constructor() {}

  ngOnInit() {}
}
